import React from 'react';
import {connect} from "react-redux";

import UserFieldElement from '../../../reusable/UserFieldElement';
import UserFieldDataType from "../../../../utils/enums/UserFieldDataTypeEnum";

import RaceList from "../common/RaceList";
import UserRoles from "../../../../../../common/src/enums/UserRoles";

class SeasonPrices extends React.Component {
    constructor(props) {
        super(props);
        this.state = Object.assign({
            raceType: props.auth.currentRole === UserRoles.SECTION_ADMIN.id ? 'section' : props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? 'ddb' : 'all',
            reportType: 'club',
            sectionFrom: '',
            sectionTo: props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? '69' : '',
            clubFrom: '',
            clubTo: props.auth.currentRole === UserRoles.MAIN_ADMIN.id || props.auth.currentRole === UserRoles.SECTION_ADMIN.id ? '299' : '',
            weekFrom: '',
            weekTo: '',
        });
    }

    fields = [];
    render() {
        return <div className="season-prices report-options">
            <div className="left-pane">
                {this.props.auth.currentRole !== UserRoles.SECTION_ADMIN.id ? <div className="radio-buttons-container">
                    <div className="radio-buttons-title">Kapflyvningstype</div>
                    <div className="radio-button-container">
                        <input id="race-type-all" type="radio" checked={this.state.raceType === 'all'} onClick={() => this.setState({raceType: 'all'})}/><label htmlFor="race-type-all">Alle flyvninger</label>
                    </div>
                    <div className="radio-button-container">
                        <input id="race-type-ddb" type="radio" checked={this.state.raceType === 'ddb'} onClick={() => this.setState({raceType: 'ddb', sectionFrom: /^[0-9]{2}$/.test(this.state.sectionFrom) ? this.state.sectionFrom : '', sectionTo: /^[0-9]{2}$/.test(this.state.sectionTo) ? this.state.sectionTo : ''})}/><label htmlFor="race-type-ddb">DDB-flyvninger</label>
                    </div>
                    <div className="radio-button-container">
                        <input id="race-type-section" type="radio" checked={this.state.raceType === 'section'} onClick={() => this.setState({raceType: 'section'})}/><label htmlFor="race-type-section">Sektionsflyvninger</label>
                    </div>
                </div> : null}
                <div className="radio-buttons-container">
                    <div className="radio-buttons-title">Layout</div>
                    <div className="radio-button-container">
                        <input id="report-type-club" type="radio" checked={this.state.reportType === 'club'} onClick={() => this.setState({reportType: 'club'})}/><label htmlFor="report-type-club">Foreningsopdelt</label>
                    </div>
                    <div className="radio-button-container">
                        <input id="report-type-club-summary" type="radio" checked={this.state.reportType === 'club-summary'} onClick={() => this.setState({reportType: 'club-summary'})}/><label htmlFor="report-type-club-summary">Foreningstotaler</label>
                    </div>
                </div>
            </div>
            <div className="right-pane">
                <table>
                    <tbody>
                    {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <tr className="field-row">
                        <td className={this.state.raceType !== 'ddb' ? '' : 'disabled'}>
                            <label htmlFor="sectionFrom">Fra sektion</label>
                        </td>
                        <td>
                            <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field-1 field100" containerClassName="display-inline-block" enabled={this.state.raceType !== 'ddb'}
                                              name="sectionFrom" id="sectionFrom" maxLength="2" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{2}"}]} value={this.state.sectionFrom}
                                              disabled={this.state.raceType === 'ddb'} autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                              onChange={this.onStandardFieldChange}
                                              onBlur={() => {
                                                  this.fields[0].setState({focused: false, visited: true});
                                                  if (/^[0-9]{2}$/.test(this.state.sectionFrom) && this.state.sectionTo === '') this.setState({sectionTo: this.state.sectionFrom});
                                              }}
                                              ref={instance => { this.fields[0] = instance; }}
                            />
                        </td>
                    </tr> : null}
                    {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <tr className="field-row">
                        <td className={this.state.raceType !== 'ddb' ? '' : 'disabled'}>
                            <label htmlFor="sectionTo">Til sektion</label>
                        </td>
                        <td>
                            <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field-1 field100" containerClassName="display-inline-block" enabled={this.state.raceType !== 'ddb'}
                                              name="sectionTo" id="sectionTo" maxLength="2" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{2}"}]} value={this.state.sectionTo}
                                              disabled={this.state.raceType === 'ddb'} autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                              onChange={this.onStandardFieldChange}
                                              ref={instance => { this.fields[1] = instance; }}
                            />
                        </td>
                    </tr> : null}
                    {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <tr className="separator"><td colSpan={2}/></tr> : null}
                    {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id || this.props.auth.currentRole === UserRoles.SECTION_ADMIN.id ? <tr className="field-row">
                        <td>
                            <label htmlFor="clubFrom">Fra forening</label>
                        </td>
                        <td>
                            <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field-1 field100" containerClassName="display-inline-block"
                                              name="clubFrom" id="clubFrom" maxLength="3" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{3}"}]} value={this.state.clubFrom}
                                              autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                              onChange={this.onStandardFieldChange}
                                              onBlur={() => {
                                                  this.fields[2].setState({focused: false, visited: true});
                                                  if (/^[0-9]{1,2}$/.test(this.state.clubFrom)) this.setState({clubFrom: this.state.clubFrom.padStart(3, '0'), clubTo: this.state.clubTo === '' ? this.state.clubFrom.padStart(3, '0') : this.state.clubTo});
                                                  else if (/^[0-9]{3}$/.test(this.state.clubFrom) && this.state.clubTo === '') this.setState({clubTo: this.state.clubFrom});
                                              }}
                                              ref={instance => { this.fields[2] = instance; }}
                            />
                        </td>
                    </tr> : null}
                    {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id || this.props.auth.currentRole === UserRoles.SECTION_ADMIN.id ? <tr className="field-row">
                        <td>
                            <label htmlFor="clubTo">Til forening</label>
                        </td>
                        <td>
                            <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field-1 field100" containerClassName="display-inline-block"
                                              name="clubTo" id="clubTo" maxLength="3" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{3}"}]} value={this.state.clubTo}
                                              autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                              onChange={this.onStandardFieldChange}
                                              onBlur={() => {
                                                  this.fields[3].setState({focused: false, visited: true});
                                                  if (/^[0-9]{1,2}$/.test(this.state.clubTo)) this.setState({clubTo: this.state.clubTo.padStart(3, '0')});
                                              }}
                                              ref={instance => { this.fields[3] = instance; }}
                            />
                        </td>
                    </tr> : null}
                    {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id || this.props.auth.currentRole === UserRoles.SECTION_ADMIN.id ? <tr className="separator"><td colSpan={2}/></tr> : null}
                    <tr className="field-row">
                        <td>
                            <label htmlFor="weekFrom">Fra uge</label>
                        </td>
                        <td>
                            <UserFieldElement dataType={UserFieldDataType.int} placeholder="" className="field-1 field100" containerClassName="display-inline-block"
                                              name="weekFrom" id="weekFrom" value={this.state.weekFrom}
                                              autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                              onChange={this.onStandardFieldChange}
                                              ref={instance => { this.fields[4] = instance; }}
                            />
                        </td>
                    </tr>
                    <tr className="field-row">
                        <td>
                            <label htmlFor="weekTo">Til uge</label>
                        </td>
                        <td>
                            <UserFieldElement dataType={UserFieldDataType.int} placeholder="" className="field-1 field100" containerClassName="display-inline-block"
                                              name="weekTo" id="weekTo" value={this.state.weekTo}
                                              autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                              onChange={this.onStandardFieldChange}
                                              ref={instance => { this.fields[5] = instance; }}
                            />
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    }

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

    allInputValid = () => {
        let result = true;
        this.fields.forEach((field) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };

    getReportOptions = () => {
        const errors = [];
        const isValid = this.allInputValid();
        if (!isValid) {
            errors.push('Der er fejl i et eller flere rapporteringsvalg).');
            this.fields.forEach((field) => {
                field.setState({visited: true});
            });
        }
        return {
            errors: errors,
            options: {
                raceType: this.state.raceType,
                reportType: this.state.reportType,
                sectionFrom: this.state.sectionFrom === '' ? null : this.state.sectionFrom,
                sectionTo: this.state.sectionTo === '' ? null : this.state.sectionTo,
                clubFrom: this.state.clubFrom === '' ? null : this.state.clubFrom,
                clubTo: this.state.clubTo === '' ? null : this.state.clubTo,
                weekFrom: this.state.weekFrom === '' ? null : Number(this.state.weekFrom),
                weekTo: this.state.weekTo === '' ? null : Number(this.state.weekTo),
            },
        };
    }
}

const mapStateToProps = (state) => ({
    auth: {
        currentRole: state.auth.currentRole,
        currentEntity: state.auth.currentEntity,
    },
});

export default connect(mapStateToProps, null, null, {withRef: true})(SeasonPrices);


// WEBPACK FOOTER //
// ./src/client/src/components/pages/reporting/subPages/SeasonPrices.js